import EasyCurrency from './easycurrency/EasyCurrency';
import GeoService from './geoservice/GeoService';

class Plugins {
    constructor() {
        /** @type {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} */
        this.EasyCurrency = EasyCurrency;
        /** @type {src/plugins/geoservice/GeoService.js~GeoService} */
        this.GeoService = GeoService;
    }
}

/** @ignore */
export default new Plugins;



// WEBPACK FOOTER //
// ./src/plugins/index.js